import { useSensorPage } from '@apis/rendall/queries/use-sensor-page';
import { Skeleton } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';
import { MINUTE_IN_MS } from 'ae-constants/constants';

export const SensorNameCell = ({ deploymentId }: { deploymentId: string }) => {
  const { data: sensorData, isLoading } = useSensorPage({
    staleTime: 5 * MINUTE_IN_MS,
  });

  if (isLoading) {
    return (
      <Stack direction="column" height="100%" justifyContent="center">
        <Skeleton data-testid="skeleton" />
      </Stack>
    );
  }

  return (
    sensorData?.items.find((sensor) => sensor.deploymentID === deploymentId)
      ?.name ?? deploymentId
  );
};
